import axios from 'axios'

const GATEWAY_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080'
const REFRESH_WINDOW_MS = 5 * 60 * 1000   // tenta renovar 5 min antes de expirar
const MIN_REFRESH_DELAY_MS = 30 * 1000    // nunca dispara em menos de 30s

let refreshTimer: ReturnType<typeof setTimeout> | null = null

function decodeJwtExp(token: string): number | null {
  try {
    const [, payloadB64] = token.split('.')
    if (!payloadB64) return null
    const padded = payloadB64 + '='.repeat((4 - payloadB64.length % 4) % 4)
    const json = atob(padded.replace(/-/g, '+').replace(/_/g, '/'))
    const payload = JSON.parse(json) as { exp?: number }
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null
  } catch {
    return null
  }
}

function scheduleProactiveRefresh(token: string): void {
  cancelProactiveRefresh()

  const expMs = decodeJwtExp(token)
  if (!expMs) return

  const refreshAt = expMs - REFRESH_WINDOW_MS - Date.now()
  const delay = Math.max(refreshAt, MIN_REFRESH_DELAY_MS)

  refreshTimer = setTimeout(async () => {
    try {
      const { data } = await axios.post(
        `${GATEWAY_URL}/auth/refresh`,
        {},
        { withCredentials: true }
      )
      const newToken = data?.tokens?.accessToken || data?.token
      if (newToken) {
        setAuthToken(newToken)
      }
    } catch {
      // Falhou. Próxima request com 401 ainda aciona refresh reativo
      // via interceptor, então não precisa redirecionar daqui.
    }
  }, delay)
}

export function cancelProactiveRefresh(): void {
  if (refreshTimer) {
    clearTimeout(refreshTimer)
    refreshTimer = null
  }
}

export function setAuthToken(token: string): void {
  localStorage.setItem('auth_token', token)
  scheduleProactiveRefresh(token)
}

export function clearAuthToken(): void {
  localStorage.removeItem('auth_token')
  cancelProactiveRefresh()
}

// Boot: se já tem token no storage (refresh da página), agenda refresh
const existingToken = localStorage.getItem('auth_token')
if (existingToken) {
  scheduleProactiveRefresh(existingToken)
}
